import axios from './client';

export default {
  getCompany(code) {
    return axios.get(`getCompany?code=${code}`);
  },
};
